import { render, staticRenderFns } from "./SystemConfiguration.vue?vue&type=template&id=783c493b&scoped=true&"
import script from "./SystemConfiguration.vue?vue&type=script&lang=js&"
export * from "./SystemConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783c493b",
  null
  
)

export default component.exports